import {ANNOTATION_VIDEO_DISPLAY, ANNOTATION_PARENT, VIDEO_PLAYING_MODE} from './GlobalConstants';
import * as THREE from 'three';

export const ANNOTATION_CONTACT_TEXT = '';
export const CONTACT_URL = 'WEBSITE';
export const YOUTUBE = 'YOUTUBE';
export const INSTAGRAM = 'INSTAGRAM';
export const SPOTIFY = 'SPOTIFY';
export const TWITTER = 'TWITTER';
export const TIKTOK = 'TIKTOK';
export const IMDB = 'IMDB';
export const FACEBOOK = 'FACEBOOK';
export const ENQUIRE_EMAIL = 'ENQUIRE';
export const LINKED_IN = 'LINKEDIN';
export const HAS_MEDIA_CAROUSEL_LINK = 'MORE';
export const SEND_TO_EMAIL = 'SEND TO';
export const CANTALOUPE_IMAGE_SERVER = "https://iiif.v21artspace.com/iiif/2/made-with-many%2Fmwm-time-to%2F"
export const ANNOTATION_TEXT_ALIGNMENT = "center";
export const ANNOTATION_TEXT_LINE_HEIGHT = "1.5";
export const GALLERY_LINK_LABEL = "WORKS";

const AnnotationsDB = [
    /* Videos begin */

    {
        //Z1V1.mp4
        paintingId: 'S05W02G01',
        videoId: 'S05W02G01',
        standaloneVideoElementId: 'S05W02G01',
        videoURL: 'S05W02G01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        headerText: 'Sample',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        videoLoop: true,
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,

    },

    {
        //Z1V1.mp4
        paintingId: 'S08W03G01',
        videoId: 'S08W03G01',
        standaloneVideoElementId: 'S08W03G01',
        videoURL: 'S08W03G01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        headerText: 'Sample',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        videoLoop: true,
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        videoButtonPos: {x: 0.18134, y: -0.714774, z: -6.48539},
        videoTextureEncoding: THREE.sRGBEncoding,

    },

    {
        //Z1V1.mp4
        paintingId: 'S08W03G02',
        videoId: 'S08W03G02',
        standaloneVideoElementId: 'S08W03G02',
        videoURL: 'S08W03G02.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        headerText: 'Sample',
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        videoLoop: true,
        videoButtonPos: {x: 0.18134, y: -0.714774, z: -8.43291},
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,

    },

    {
        paintingId: 'S03W03V01',
        videoId: 'S03W03V01',
        standaloneVideoElementId: 'S03W03V01',
        videoURL: 'S03W03V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
    },
    {
        paintingId: 'S05W04V01',
        videoId: 'S05W04V01',
        standaloneVideoElementId: 'S05W04V01',
        videoURL: 'S05W04V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
    },
    {
        paintingId: 'S07W02V01',
        videoId: 'S07W02V01',
        standaloneVideoElementId: 'S07W02V01',
        videoURL: 'S07W02V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: `<h5>Alienated World 2.0</h5>`,
        bodyText: `Alienated world 2.0, is a stop motion piece which pays homage to those souls who have lost their battle with the Coronavirus (Covid19). Small chairs are presented in the form of an implied narrative within the space. Chairs are symbolically used to represent the memory of the deceased. A thousand little chairs slither on the ground, in great numbers, invading the domestic space, moving and exploring the different corners of the house at speed. They are trying to break through and to become a part of something bigger, perhaps.<br>Michal Rovner's (Frequency - a trace of life project), Gormley's Field (1989), and Sarah Sze's Extended play (1998) are the major sources of inspiration.`,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
    },
    {
        paintingId: 'S07W04V01',
        videoId: 'S07W04V01',
        standaloneVideoElementId: 'S07W04V01',
        videoURL: 'S07W04V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: `<h5>The Seven Lives of Caesar</h5>`,
        bodyText: `Fear, hope, and dread. These are all we think when we ponder what happens to us after we die, death is something which we don't want to accept. We all fear death. Everyone is frightened because no one knows what's going to happen after we die, where we come from and where will we go? These are the questions which we don’t have any answers for, but it is our belief which leads us to have various hypotheses. According to science, death is when the body ceases to function, which means the end of life. Yet an imaginative human mind wants to believe that life after death proceeds in multiple ways. Different religious texts (Christian, Islam, Hindu, Judaism, Buddhism, and many more) are the major source which supports the idea of an afterlife. The major inspiration comes from different religious-philosophical texts which contained plenty of wonderful explanations about Metempsychosis. For instance, most have faith in the reincarnation or heaven and hell or that a soul may exist in other realms.<br>Being born in a Hindu family, I have been intrigued by the notions of seven life after a man dies which is present in "Garud Puran”(Hindus religious text), it is especially recited during the 13 days after the death of an inhabitant of a home for the salvation of a soul. The text contains the theory of "heaven and hell" with karma and rebirth. “The Seven lives " is called "Saat Janma '' in Sanskrit and similarly, Buddhism also follows the same notion which depicts several reincarnation stories of Buddha. So, this animation called “The Seven Lives of Caesar" is about my interpretation of how life formulates after the demise of a person in a miniature setup. Quay Brothers, Saskia Olde Wolber, William Kentridge, Nathalie Djurberg and Hans Berg, Jan Svankmajer are major sources of inspiration to create this stop-motion.<br>The theory of seven lives suggests that living beings will reincarnate over and over again, after which that soul will attain liberation (moksha). I believe that we all have our purpose in this world. The human being is created to celebrate, to respect, and to serve, and to preserve his or her soul. All other objects on the face of the planet are made for human beings and allow them to achieve the purpose for which they are made. The short animation is about the reincarnation of an old man and his struggle through his seven lives. The story starts with an old man and the solitary journey of his soul.`,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
    },
    {
        paintingId: 'S09W01V01',
        videoId: 'S09W01V01',
        standaloneVideoElementId: 'S09W01V01',
        videoURL: 'S09W01V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
    },
    {
        paintingId: 'S09W02V01',
        videoId: 'S09W02V01',
        standaloneVideoElementId: 'S09W02V01',
        videoURL: 'S09W02V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
    },
    {
        paintingId: 'S09W03V01',
        videoId: 'S09W03V01',
        standaloneVideoElementId: 'S09W03V01',
        videoURL: 'S09W03V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
    },
    {
        paintingId: 'S10W02V01',
        videoId: 'S10W02V1',
        standaloneVideoElementId: 'S10W02V01',
        videoURL: 'S10W02V01.mp4',
        isMediaUsed: 'N',
        // iframeSource: "http://www.careweaving.org/",
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_TEXT,
        headerText: `<h5>Care Weaving Website</h5>`,
        bodyText: `Please click the link below to experience the Care Weaving website for yourself`,
        urlLink1Label: "WWW.CAREWEAVING.ORG",
        urlLink1: "http://www.careweaving.org/",
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_AUTO_PLAY_NO_BUTTONS,
        videoLoop: true,
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
    },
    /* Videos end */


    //S00 annotations
    {
        paintingId: 'S00P01',
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?d=cataloguefinalbinder&hideIssuuLogo=true&u=mixedrealitiesltd',
        headerText: `<h5>Where Are We Now?</h5>`,
        bodyText: null,
    },
    // S03 annotations
    {
        paintingId: 'S03W01T01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Deljeet K. Singh</h5>`,
        bodyText: `As a British Indian artist, I have taken it upon myself to explore my roots by delving into pattern and its origins. I started this complex study by exploring pattern from such diverse cultures as Moroccan, Egyptian, Greek, French, Dutch, Islamic, Chinese, North American Indian, Aboriginal and also graffiti,
discovering a great patchwork of material in many different styles which I draw on for my own practice.<br>In 2013, after graduating with a BA in Fashion and Business studies, I set up my own business in textile design. Since then, I have found a way to design patterns on my mobile phone that I then take further through Photoshop.<br>
This project features print designs made from drawings and paintings that were made during the process of my research.`,
        EnquireEmail: 'delishartanddesign@hotmail.co.uk',
        instagramUrl: 'https://www.instagram.com/delish.art.and.design/?hl=en',
    },
    {
        paintingId: 'S03W01P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S03W01P01.jpg`,
        headerText: `<h5>Untitled</h5>`,
        bodyText: null,
    },
    {
        paintingId: 'S03W01P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S03W01P02.jpg`,
        headerText: `<h5>Lenga’s & Vans</h5>`,
        bodyText: null,
    },
    {
        paintingId: 'S03W01P03',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S03W01P03.jpg`,
        headerText: `<h5>Gudhi</h5>`,
        bodyText: null,
    },
    {
        paintingId: 'S03W01P04',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S03W01P04.jpg`,
        headerText: `<h5>Diddi</h5>`,
        bodyText: null,
    },
    {
        paintingId: 'S03W02P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S03W02P01.jpg`,
        headerText: `<h5>Diva’s</h5>`,
        bodyText: null,
    },
    {
        paintingId: 'S03W02P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S03W02P02.jpg`,
        headerText: `<h5>Moonchild</h5>`,
        bodyText: null,
    },
    {
        paintingId: 'S03W02P03',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S03W02P03.jpg`,
        headerText: `<h5>Distant Traveller</h5>`,
        bodyText: null,

    },
    {
        paintingId: 'S03W02P04',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S03W02P04.jpg`,
        headerText: `<h5>3 Shades of Brown</h5>`,
        bodyText: null,

    },

// S04 annotations
    {
        // paintingId: 'S04W01T01',
        paintingId: 'S04W04T01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Hillary Barnes</h5>`,
        bodyText: `I recently completed a Masters in Printmaking at Middlesex University, as a mature student. I work mainly with etching, preferring monochromatic prints and stark images, influenced by the great masters of the art both historical and current.<br>My interest in architecture, background in photography, involvement in housing campaigns and community activism from the 1970’s to the present time are reflected in my early etchings, and more recently developed into the three prints in this exhibition.<br><b>‘Time the Devourer of All Things’</b> is a view of East London, from the publicly accessible roof terrace at 120 Fenchurch Street. In the foreground is the building site, backed by a mix of modern high-rise offices and buildings sitting within earlier edifices spared from destruction for the time being.<br> <b>‘Reconstruction’</b> is an example of the preservation of an old building, this one in Cavendish Square, and <b>‘In the Shadow of Giants’</b> is a view from the Regents Canal of the towers which will become the headquarters of Google in Kings Cross.<br>Research into my family revealed an ancestor, a lithographer who exhibited at what was then the Royal Polytechnic Institute in upper Regents Street. <b>‘Ancestry G J Cox’</b> was developed from one of his lithographs.<br><b>‘Siblings’</b> is my own family, a dysfunctional and pugnacious group of faceless children, and <b>‘Alan and Geoffrey’</b> a reimagining of two uncles, both killed in their teens in WW1.<br>The <b>‘Handley Page Hurricane Bomber’</b>was produced for the 2020 commemorative exhibition of the Blitz at the RAF Museum, Hendon, my final print before the pandemic drove us behind doors. <b>‘Bin’</b> is the first print since having access to a print workshop, at the Working Men’s College in Camden.<br>
I find etching totally absorbing at the same time as constantly challenging. There are so many ways of producing a printable image from a metal plate. Learning the rules, then perverting them, appeals to my baser instincts. The risks, the possibility of disaster, the serendipitous outcomes embody many of the elements which excite me. My work is illustrative, rather than conceptual and tends towards melancholy and retrospection, reflecting my own journey through the third age.`,
        EnquireEmail: 'Hilbarnes48@gmail.com',
        ContactURL: 'https://hilbarnesprints.weebly.com/',

    },
    {
        paintingId: 'S04W01P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S04W01P01.jpg`,
        headerText: `<h5>Time, the devourer of all things</h5>`,
        bodyText: null,

    },
    {
        paintingId: 'S04W01P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S04W01P02.jpg`,
        headerText: `<h5>Reconstruction</h5>`,
        bodyText: null,

    },
    {
        paintingId: 'S04W02P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S04W02P01.jpg`,
        headerText: `<h5>In the shadow of giants</h5>`,
        bodyText: null,

    },
    {
        paintingId: 'S04W02P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S04W02P02.jpg`,
        headerText: `<h5>Alan & Geoffrey</h5>`,
        bodyText: null,

    },
    {
        paintingId: 'S04W03P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S04W03P01.jpg`,
        headerText: `<h5>Ancestry G J Cox</h5>`,
        bodyText: null,

    },
    {
        paintingId: 'S04W03P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S04W03P02.jpg`,
        headerText: `<h5>Siblings</h5>`,
        bodyText: null,

    },
    {
        paintingId: 'S04W04P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S04W04P01.jpg`,
        headerText: `<h5>Handley Page Halifax Bomber</h5>`,
        bodyText: null,

    },
    {
        paintingId: 'S04W04P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S04W04P02.jpg`,
        headerText: `<h5>Bin</h5>`,
        bodyText: null,

    },

// S05 annotations
    {
        paintingId: 'S05W01T01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Rita Krupaviciute</h5>`,
        bodyText: `Arrivals, chaos, more arrivals, departures and even more chaos, and suddenly everything has ceased – nowhere to go, no reason for the chaos. This is how the initial idea for the major project has been developed in terms of the experience of the character travelling in liminal space in the underground and facing lockdown during the Covid19.<br>According to Marcel Duchamp, the beauty of indifference has its aethetic. The importance of unimportant things became the key. Noise, chaos, disorder, struggling, the feeling of being trapped or locked during lockdown, the anecdotal evidence and the efforts to find a balance between all that.<br>The animation <i>A Nightmare</i> is dynamic and has a psychological aspect. It is more about the emotions than the narrative. It is the reflection of memories, observation and spontaneous reaction to daily life; personal and other people‘s experiences. The simple and minimalistic techniques, the limited palette of the drawings-paintings express the character‘s desire to get out of the underground, which looks like a claustrophobic place, as well as the nostalgia of regular life, during the times of the pandemic.<br>The unstretched canvas paintings and the newspaper Globe are a challenge to manifest the struggle in the ‘upside down’ world, with its unsteadiness, tension, and the dominant negative news. It is the response to an emotional engagement, which is always a powerful means in the process of creativity.<br>There are hardly any boundaries between the drawings and paintings of the images. They are more compulsive and speedy, to demonstrate the fragmentation or a hint of the object, to arouse sensations. The figurative accuracy is not the intention in the drawings-paintings.`,
        EnquireEmail: 'r.krupaviciute@gmail.com',
        ContactURL: 'http://www.ritakarts.com',
        instagramUrl: 'https://www.instagram.com/ritak.arts/',
    },
    {
        paintingId: 'S05W01P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S05W01P01.jpg`,
        headerText: `<h5>THE UPSIDE DOWN WORLD</h5>`,
        bodyText: `acrylic on canvas, 184 x 100, 2020.`,
    },
    {
        paintingId: 'S05W01P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S05W01P02.jpg`,
        headerText: `<h5>FIGHTING WITH A NIGHTMARE</h5>`,
        bodyText: `acrylic on unstretched canvas, 184 x 150, 2020.`,
    },
    {
        paintingId: 'S05W03P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S05W03P01.jpg`,
        headerText: `<h5>NO</h5>`,
        bodyText: `acrylic on unstretched canvas, 184 x 180, 2020.`,
    },
    {
        paintingId: 'S05W03P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S05W03P02.jpg`,
        headerText: `<h5>TOMORROW IS ANOTHER DAY</h5>`,
        bodyText: `acrylic, oil and oil pastels on stretched canvas, 150 x 100, 2020.`,
    },
    // S06 annotations
    {
        paintingId: 'S06W01P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S06W01P01.jpg`,
        headerText: `<h5>Primal Wound</h5><h6>Amanda Seaborn</h6>`,
        bodyText: `<i>Etching</i><br>Original approx. 42 x 30 cm (A3)`,
        ContactURL: `https://amandaseaborn.com/`,
        EnquireEmail: 'amanda@amandaseaborn.com',
    },
    {
        paintingId: 'S06W01P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S06W01P02.jpg`,
        headerText: `<h5>Life Form</h5><h6>Amanda Seaborn</h6>`,
        bodyText: `<i>Etching</i><br>Original approx. 42 x 30 cm (A3)`,
        ContactURL: `https://amandaseaborn.com/`,
        EnquireEmail: 'amanda@amandaseaborn.com',
    },
    {
        paintingId: 'S06W01P03',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S06W01P03.jpg`,
        headerText: `<h5>Intrusion</h5><h6>Amanda Seaborn</h6>`,
        bodyText: `<i>Etching</i><br>Original approx. A2`,
        ContactURL: `https://amandaseaborn.com/`,
        EnquireEmail: 'amanda@amandaseaborn.com',
    },
    {
        paintingId: 'S06W01P04',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S06W01P04.jpg`,
        headerText: `<h5>Synapse</h5><h6>Amanda Seaborn</h6>`,
        bodyText: `<i>Cyanotype</i><br>Original approx. A5`,
        ContactURL: `https://amandaseaborn.com/`,
        EnquireEmail: 'amanda@amandaseaborn.com',
    },
    {
        paintingId: 'S06W01P05',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S06W01P05.jpg`,
        headerText: `<h5>Disconnect</h5><h6>Amanda Seaborn</h6>`,
        bodyText: `<i>Etching</i><br>Original approx. 42 x 30 cm (A3)`,
        ContactURL: `https://amandaseaborn.com/`,
        EnquireEmail: 'amanda@amandaseaborn.com',
    },
    {
        paintingId: 'S06W02P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S06W02P01.jpg`,
        headerText: `<h5>Lifelines, Molten</h5><h6>Amanda Seaborn</h6>`,
        bodyText: `<i>Etching</i>Original approx. 42 x 30 cm (A3)`,
        ContactURL: `https://amandaseaborn.com/`,
        EnquireEmail: 'amanda@amandaseaborn.com',
    },
    {
        paintingId: 'S06W02P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S06W02P02.jpg`,
        headerText: `<h5>Out of her depth</h5><h6>Amanda Seaborn</h6>`,
        bodyText: `i>Hand Coloured Etching</i><br>Original approx. A5`,
        ContactURL: `https://amandaseaborn.com/`,
        EnquireEmail: 'amanda@amandaseaborn.com',
    },
    {
        paintingId: 'S06W02P03',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S06W02P03.jpg`,
        headerText: `<h5>Not Dancing</h5><h6>Amanda Seaborn</h6>`,
        bodyText: `<i>Etching</i><br>Original approx. 42 x 30 cm (A3)`,
        ContactURL: `https://amandaseaborn.com/`,
        EnquireEmail: 'amanda@amandaseaborn.com',
    },
    {
        paintingId: 'S06W02P04',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S06W02P04.jpg`,
        headerText: `<h5>Glimmer, Stitched Up</h5><h6>Amanda Seaborn</h6>`,
        bodyText: `<i>Monotype</i><br>Original approx. A5`,
        ContactURL: `https://amandaseaborn.com/`,
        EnquireEmail: 'amanda@amandaseaborn.com',
    },
    {
        paintingId: 'S06W02P05',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S06W02P05.jpg`,
        headerText: `<h5>Crucible</h5><h6>Amanda Seaborn</h6>`,
        bodyText: `<i>Etching</i><br>Original approx. 42 x 30 cm (A3)`,
        ContactURL: `https://amandaseaborn.com/`,
        EnquireEmail: 'amanda@amandaseaborn.com',
    },
// S07 annotations
    {
        paintingId: 'S07W01T01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Bidushi Thapa</h5>`,
        bodyText: `My artist practice has always been revolved around miniature stuff. It all started with a genuine curiosity that brings me to the world of the miniature genre of art. I believe that miniature art has been a constructive vehicle for sharing past knowledge and has continued to bring out a strong influence on culture. It was thought to be a movable image vehicle as a result it has allowed people to connect with cultures, gender from diverse social backgrounds. In my work, I've tried to show what significance does miniature art play to become the most powerful way to share personal experiences? why does it make us feel nostalgic?<br>What I've understood is that miniature is not only about the amount of discipline, endurance, intense labour, skills, and investment that goes for the creation of something extraordinary but also about making an intimate connection with the object by both the makers and the viewers. Miniature art has a bigger impact on our senses and its tininess has made us realised to indulge and respect the power of its smallness. My works are the result of my understanding and skills which I've developed through this process. The surroundings always have inspired me to come up with major sources of ideas. That's why, the recent works reflect on the current (Global Pandemic) issues and struggles, that we are dealing with, where everybody has been compelled to stay quarantine for our protection from my perspective. Similarly, the core theme of my art practice has been regarding solitude and loneliness, which I've always sought to communicate with viewers through narrative. I think that contemplating on these subjects will make my project more relevant.<br>Initially, I've thought of producing an installation for the major project but due to the lockdown I was left with the constraint of materials and lack of space, so I believe that animation is a wonderful self-explanatory medium to demonstrate the present context in a miniature setup, owing to its remarkable capacity to communicate through various emotions and ideas.`,
        EnquireEmail: 'r.krupaviciute@gmail.com',
        ContactURL: 'http://www.ritakarts.com',
        instagramUrl: 'https://www.instagram.com/ritak.arts/',
    },
// S09 annotations
    {
        paintingId: 'S09W04T01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Vika Cheng</h5>`,
        bodyText: `My creation is to make a virtual record of my wishful dish that has impacted my life greatly. My works are based on my memories and these stories are told through my virtual cooking video. Not only does food provide us with essential daily nutrients, it perhaps is also one of the best way to comfort our souls. While memory might fade overtime, it is food that happens to constantly vivify these memories, which I care very much about.<br>My grandfather passed away during this pandemic, which means I will never again enjoy a favourite dish my grandfather used to make since I was a child. The taste, and more importantly, the intimacy attached to it, is irreplaceable. That special fried fish dish represents my childhood; his love for me, is scotched deeply in my memory through this simple, yet special dish.<br>Food to me is the most effective nonverbal communication as this is one of the best ways that we can show our love to our beloved one, family or friends. Love is always the most important ingredient to make any dish taste special. It also shares the nostalgia, the bridge that connects you with the object/ human/ memory/ place. Whenever I leave my hometown, I always search for my hometown cuisine and ask my family for their “secret” recipe. It might not be the best recipe for the most delicious cuisine but it surely makes me feel at home.<br>Vika Cheng studied MA Fine art at Middlesex University, she has an BA in Journalism and Mass Communication from the Hong Kong Shue Yan University. She is a feng shui Painter, freelance creative inspirer and creative video producer. She has been a guest teacher for a one-day workshop in Hong Kong Design Association. Her feng shui paintings were purchased for clients from UBS, Beacon College, lawyer’s office etc… Creative stop-motion videos were commissioned by Hong Kong Tourism Board, 友利冰室, MG motor.`,
        instagramUrl: 'https://www.instagram.com/vikacheng.art/?hl=en',
    },
//    S10 annotations
    {
        paintingId: 'S10W02P01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>What Do You Think?</h5>`,
        bodyText: `<b>What is care to you?</b><br><br>If you were to define ‘care’ in a manifesto, what would you include? Click the link below to leave your comment.`,
        ContactURL: 'https://padlet.com/isobelreddington/CareWeavingQuestion',
        spriteImageURL: process.env.PUBLIC_URL + '/assets/sprites/Feedbackicon.svg',
        annotationScale: {x: .45, y: .45, z: 1},
        annotationPos: {x: .295, y: -.5, z: 14.05},
    },
// S11 annotations
    {
        paintingId: 'S11W01P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S11W01P01.jpg`,
        headerText: `<h5>Astra</h5><h6>Ellery Lin</h6>`,
        bodyText: `Linocut with watercolour, August 2020, 35x35 centimetre`,
    },
    {
        paintingId: 'S11W01P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S11W01P02.jpg`,
        headerText: `<h5>Thorn Maze</h5><h6>Ellery Lin</h6>`,
        bodyText: `Linocut with watercolour, August 2020, 45.4x36 centimetre`,
    },
    {
        paintingId: 'S11W01P03',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S11W01P03.jpg`,
        headerText: `<h5>The Helmet</h5><h6>Ellery Lin</h6>`,
        bodyText: `Linocut with watercolour, September 2020, 35x35 centimetre`,
    },
    {
        paintingId: 'S11W01P04',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S11W01P04.jpg`,
        headerText: `<h5>Emerald Protector</h5><h6>Ellery Lin</h6>`,
        bodyText: `Linocut with watercolour, September 2020, 45.4x36 centimetre`,
    },
    {
        paintingId: 'S11W01P05',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S11W01P05.jpg`,
        headerText: `<h5>Stained Glass Star</h5><h6>Ellery Lin</h6>`,
        bodyText: `Linocut with watercolour, September 2020, 35x35 centimetre`,
    },
    {
        paintingId: 'S11W01P06',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S11W01P06.jpg`,
        headerText: `<h5>Bramble Wetland</h5><h6>Ellery Lin</h6>`,
        bodyText: `Linocut with watercolour, September 2020, 45.4x36 centimetre`,
    },
    {
        paintingId: 'S11W02P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S11W02P01.jpg`,
        headerText: `<h5>Designer Protection</h5><h6>Ellery Lin</h6>`,
        bodyText: `Linocut with watercolour, September 2020, 35x35 centimetre`,
    },
    {
        paintingId: 'S11W02P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S11W02P02.jpg`,
        headerText: `<h5>Armoured Junction</h5><h6>Ellery Lin</h6>`,
        bodyText: `Linocut with watercolour, August 2020, 45.4x36 centimetre`,
    },
    {
        paintingId: 'S11W02P03',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S11W02P03.jpg`,
        headerText: `<h5>The Cuirass</h5><h6>Ellery Lin</h6>`,
        bodyText: `Linocut with watercolour, September 2020, 35x35 centimetre`,
    },
    {
        paintingId: 'S11W02P04',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S11W02P04.jpg`,
        headerText: `<h5>Open Arms</h5><h6>Ellery Lin</h6>`,
        bodyText: `Linocut with watercolour, August 2020, 45.4x36 centimetre`,
    },
    // S12 annotations
    {
        paintingId: 'S12W01P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S12W01P01.jpg`,
        headerText: `<h5>Shard Aluminium</h5>`,
        bodyText: 'Aluminium Print, 16.8 x 25cm',
    },
    {
        paintingId: 'S12W01P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S12W01P02.jpg`,
        headerText: `<h5>Aldgate East</h5>`,
        bodyText: 'Aluminium Print, 21 x 25cm',
    },
    {
        paintingId: 'S12W01P03',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S12W01P03.jpg`,
        headerText: `<h5>Gherkin Aluminium</h5>`,
        bodyText: 'Aluminium Print, 16.8 x 25cm',
    },
    {
        paintingId: 'S12W01P04',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S12W01P04.jpg`,
        headerText: `<h5>Black and Pewterprint</h5>`,
        bodyText: '15 x 10.2cm',
    },
    {
        paintingId: 'S12W01P05',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S12W01P05.jpg`,
        headerText: `<h5>Red and White Acrylic Print</h5>`,
        bodyText: '20.5 x 15.5cm',
    },
    {
        paintingId: 'S12W01P06',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S12W01P06.jpg`,
        headerText: `<h5>Green, Gold and White print</h5>`,
        bodyText: 'Spray Paint, 30 x 21cm',
    },
    {
        paintingId: 'S12W01P07',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S12W01P07.jpg`,
        headerText: `<h5>Gold and White Stencil Print</h5>`,
        bodyText: '21 x 15cm',
    },
    {
        paintingId: 'S12W01P08',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S12W01P08.jpg`,
        headerText: `<h5>Doodle 2</h5>`,
        bodyText: 'Screen Print, 15 x 10cm',
    },
    {
        paintingId: 'S12W01P09',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S12W01P09.jpg`,
        headerText: `<h5>Doodle 3</h5>`,
        bodyText: 'Screen Print, 16.5 x 18cm',
    },
    {
        paintingId: 'S12W01P10',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S12W01P10.jpg`,
        headerText: `<h5>Doodle 1</h5>`,
        bodyText: 'Screen Print, 15 x 10cm',
    },
    {
        paintingId: 'S12W02P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S12W02P01.jpg`,
        headerText: `<h5>Etched Square Bracelet</h5>`,
        bodyText: 'Perspex, 20 x 17.58cm',
    },
    {
        paintingId: 'S12W02P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S12W02P02.jpg`,
        headerText: `<h5>Screen Print Earrings</h5>`,
        bodyText: 'Perspex, 20 x 17.48cm',
    },
    {
        paintingId: 'S12W02P03',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S12W02P03.jpg`,
        headerText: `<h5>Braille Rings</h5>`,
        bodyText: 'Aluminium Print, 17.5 x 21.16cm',
    },
    {
        paintingId: 'S12W02P04',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S12W02P04.jpg`,
        headerText: `<h5>Etched Bird Earrings</h5>`,
        bodyText: 'Perspex, 20 x 17.16cm',
    },
    {
        paintingId: 'S12W02P05',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S12W02P05.jpg`,
        headerText: `<h5>Braille Necklace</h5>`,
        bodyText: 'Aluminium Print, 15 x 24.4cm',
    },
    {
        paintingId: 'S12W02P06',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S12W02P06.jpg`,
        headerText: `<h5>Etched Necklace</h5>`,
        bodyText: 'Perspex, 17 x 20.67cm',
    },
    {
        paintingId: 'S12W02P07',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S12W02P07.jpg`,
        headerText: `<h5>Screen Print Waterfall Necklace</h5>`,
        bodyText: 'Perspex, 23.5 x 15cm',
    },
    // S14 annotations
    {
        paintingId: 'S14W01P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S14W01P01.jpg`,
        headerText: `<h5>Action Box</h5>`,
        bodyText: null,
    },
    {
        paintingId: 'S14W01P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S14W01P02.jpg`,
        headerText: `<h5>Babies Steelworks and Japan</h5>`,
        bodyText: null,
    },
    {
        paintingId: 'S14W01P03',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S14W01P03.jpg`,
        headerText: `<h5>Babies Steelworks and Japan</h5>`,
        bodyText: null,
    },
    {
        paintingId: 'S14W02P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S14W02P01.jpg`,
        headerText: `<h5>Arriving in the Smoke</h5>`,
        bodyText: null,
    },
    {
        paintingId: 'S14W02P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S14W02P02.jpg`,
        headerText: `<h5>Boxing timeline</h5>`,
        bodyText: null,
    },
    {
        paintingId: 'S14W02P03',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S14W02P03.jpg`,
        headerText: `<h5>Japan in Motion</h5>`,
        bodyText: null,
    },
    {
        paintingId: 'S14W02P04',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S14W02P04.jpg`,
        headerText: `<h5>Sound System</h5>`,
        bodyText: null,
    },
    {
        paintingId: 'S14W02P05',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S14W02P05.jpg`,
        headerText: `<h5>Boxing XXX</h5>`,
        bodyText: null,
    },
    {
        paintingId: 'S14W02P06',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S14W02P06.jpg`,
        headerText: `<h5>Dragon</h5>`,
        bodyText: null,
    },
    {
        paintingId: 'S14W02P07',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/S14W02P07.jpg`,
        headerText: `<h5>Japan in Motion</h5>`,
        bodyText: null,
    },
];

export {AnnotationsDB};
